export enum Page {
  LOADING_TRIALS = 'LOADING_TRIALS',
  CONSENT = 'CONSENT',
  INTRODUCTION = 'INTRODUCTION',
  TRIALS = 'TRIALS',
  DEMOGRAPHICS_INSTRUCTIONS = 'DEMOGRAPHICS_INSTRUCTIONS',
  DEMOGRAPHICS = 'DEMOGRAPHICS',
  DEBRIEFING = 'DEBRIEFING',
}
